import { render, staticRenderFns } from "./ComBox.vue?vue&type=template&id=4580d9e7&scoped=true"
import script from "./ComBox.vue?vue&type=script&lang=js"
export * from "./ComBox.vue?vue&type=script&lang=js"
import style0 from "./ComBox.vue?vue&type=style&index=0&id=4580d9e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580d9e7",
  null
  
)

export default component.exports